import { NATIVE_FORM_FIELD_ERRORS } from "./native-form-field-errors.const";

// eslint-disable-next-line @tseslint/typedef
export const FORM_FIELD_ERRORS = { ...NATIVE_FORM_FIELD_ERRORS } as const;
